"use client"
/* */
const locales = {"de-DE": {  "link.download": `Download`,
  "link.external": `Externer Link`,
},"en-US": {  "link.download": `Download`,
  "link.external": `External link`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@d7a4ca29c343fa700bb5aa84d322958b.mjs.map
